import { render, staticRenderFns } from "./Anomaly.vue?vue&type=template&id=2c1dd97d&scoped=true&"
import script from "./Anomaly.vue?vue&type=script&lang=js&"
export * from "./Anomaly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1dd97d",
  null
  
)

export default component.exports